import React from 'react';
import CheckCircleIcon from '@heroicons/react/24/solid/CheckCircleIcon';

let stages = [
  {
    slug: 'select',
    label: 'Select',
  },
  {
    slug: 'summary',
    label: 'Summary',
  },
  {
    slug: 'confirmation',
    label: 'Confirmation',
  },
];

export default function Progress({ stage, queryParams }) {
  let queryParamsString = '';
  if (queryParams) {
    let queryParamsObj = new URLSearchParams(queryParams);
    queryParamsString = '?' + queryParamsObj.toString();
  }

  return (
    <div className="flex py-6 bg-white items-center align-middle text-slate-700">
      {stages.map((oneStage, index) => {
        return (
          <React.Fragment key={'progress-' + index}>
            <div
              className={
                'flex-0 flex flex-col' + (stage >= index + 1 ? '  text-mint-700' : '')
              }
            >
              {stage < index + 1 && (
                <span className="text-slate-500 text-center text-sm">{index + 1}</span>
              )}
              {stage >= index + 1 && (
                <CheckCircleIcon className="text-mint-600 mb-1 h-5 w-5 self-center" />
              )}
              {index + 1 < stage && stage !== 3 ? (
                <a href={`/gifts/${oneStage.slug}${queryParamsString}`}>
                  {oneStage.label}
                </a>
              ) : (
                oneStage.label
              )}
            </div>
            {index < stages.length - 1 && (
              <div className="flex-1 mx-2 lg:mx-4">
                <hr className="border-slate-300" />
              </div>
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
